module.exports = __webpack_public_path__ + "img/bg_topbar_dark.e520b3f3.png";